import { ActionIcon, createStyles, Group, Menu, Text } from '@mantine/core';
import React, { useState } from 'react';
import { Row, UseExpandedRowProps } from 'react-table';

import { ConnectedPartner } from '@portals/api/partners';
import { ReactComponent as Plus } from '@portals/icons/linear/add-square.svg';
import { ReactComponent as ArrowSquareDown } from '@portals/icons/linear/arrow-square-down.svg';
import { useOpenModal } from '@portals/redux';

import { CreateNewPartnerTypeModalProps } from '../../modals';

export interface TypeProps {
  relationshipType: string;
  row: Row<ConnectedPartner> & UseExpandedRowProps<ConnectedPartner>;
  onUpdateType: (id: string[], relationshipType: string) => void;
  relationshipTypes: string[] | undefined;
}

export function PartnerType({
  relationshipType,
  row,
  onUpdateType,
  relationshipTypes,
}: TypeProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const openModal = useOpenModal();

  const { classes, cx } = useStyles();

  return (
    <Group
      px="md"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      noWrap
    >
      <Text w="100%" align="left" size="sm" color="blue_gray.7">
        {relationshipType}
      </Text>

      <Menu
        position="bottom-end"
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
      >
        <Menu.Target>
          <ActionIcon
            variant="subtle"
            color="blue_gray"
            size="md"
            className={cx(classes.button, {
              'is-visible': isOpen || isHovered,
            })}
          >
            <ArrowSquareDown />
          </ActionIcon>
        </Menu.Target>

        <Menu.Dropdown>
          {relationshipTypes?.map((relationshipType) => (
            <Menu.Item
              key={relationshipType}
              onClick={() => onUpdateType([row.original.id], relationshipType)}
              className={cx({
                [classes.menuItemValueSameAsLabelValue]:
                  row.original.relationship_type === relationshipType,
              })}
            >
              {relationshipType}
            </Menu.Item>
          ))}

          <Menu.Divider />
          <Menu.Item
            onClick={() =>
              openModal<CreateNewPartnerTypeModalProps['data']>(
                'CreateNewPartnerTypeModal',
                {
                  onChange: (relationshipType: string) =>
                    onUpdateType([row.original.id], relationshipType),
                }
              )
            }
            icon={<Plus />}
          >
            Create New
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Group>
  );
}

const useStyles = createStyles((theme) => ({
  button: {
    display: 'none',

    '&.is-visible': {
      display: 'unset',
    },
  },
  menuItemValueSameAsLabelValue: {
    color: theme.colors.primary['4'],
  },
}));
